import React from "react";
import { datadogRum } from "@datadog/browser-rum";

import useUser from "../components/Login/useUser";
import { getEnvironmentOrDefault } from "../utilities/environment";

const ENVIRONMENT = getEnvironmentOrDefault();

/** This custom hook sets user object for datadog app monitoring */
export default function useDatadogUser() {
  const user = useUser();
  const name = user?.name;
  const username = user?.username;
  // homeAccountId is {oid}.{tid} - uniquely identifies the user across tenants.
  const userId = user?.homeAccountId;

  React.useEffect(() => {
    if (
      ENVIRONMENT !== "local-dev" &&
      userId !== undefined &&
      name !== undefined &&
      username !== undefined
    ) {
      datadogRum.setUser({
        id: userId,
        name: name,
        // We assume the username is an email address. DataDog wants an email,
        // but apparently Microsoft/Azure handles emails in a weird way. FWIW,
        // I've only ever seen usernames that are email addresses in Corteva apps
        // that use Azure for auth.
        // https://learn.microsoft.com/en-us/entra/identity-platform/migrate-off-email-claim-authorization
        email: username,
      });
    }
  }, [userId, name, username]);
}
